<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousDash" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true"
                >skip_previous</md-icon
              >Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Reports</b-navbar-brand>
        </b-navbar>
        <b-card class="formCard">
          <b-card-text>
            <div class="gutr">
              <!-- Using modifiers -->
              <b-button variant="outline-dark" v-b-toggle.collapse-2 class="m-1"
                >Filters</b-button
              >
              <b-dropdown
                size="sm"
                dropleft
                variant="outline-dark"
                text="Export"
                class="m-2 pull-right"
              >
                <!-- <b-dropdown-item-button @click="onDownloadPDF">Export as PDF</b-dropdown-item-button> -->
                <b-dropdown-item-button @click="onDownloadExcel"
                  >Export as Excel</b-dropdown-item-button
                >
              </b-dropdown>

              <b-collapse id="collapse-2">
                <b-card class="gutr">
                  <md-layout md-gutter>
                    <md-layout md-flex="30" md-flex-small="100">
                      <model-list-select
                        :isDisabled="clientType == '2'"
                        :list="clientMaster"
                        id="clientNamenew"
                        v-model="clientId"
                        option-value="clientId"
                        option-text="clientName"
                        placeholder="Select  Client Name"
                      ></model-list-select>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="20" md-flex-small="100">
                      <model-list-select
                        :list="jTypeList"
                        v-model="jobType"
                        option-value="jTypeVal"
                        option-text="jTypeText"
                        placeholder="Select Job Type "
                      ></model-list-select>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="15" md-flex-small="100">
                      <model-list-select
                        :list="shipmentTypeList"
                        v-model="shipmentType"
                        option-value="shipmentTypeVal"
                        option-text="shipmentTypeText"
                        placeholder="Select Sea / Air"
                      ></model-list-select>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="20" md-flex-small="100">
                      <model-list-select
                        :list="transportTypeName"
                        v-model="transportType"
                        option-value="transportTypeVal"
                        option-text="transportTypeText"
                        placeholder="Select Export / Import"
                      ></model-list-select>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter class="gutr">
                    <md-layout md-flex="30" md-flex-small="100">
                      <model-list-select
                        @input="
                          getLocationList($event, 'All', 'finalAllPlaceDataPOR')
                        "
                        @searchchange="
                          getLocationList($event, 'All', 'finalAllPlaceDataPOR')
                        "
                        :list="finalAllPlaceDataPOR"
                        v-model="PORfilter"
                        option-value="pickupId"
                        option-text="pickupLocation"
                        placeholder="Select Place of Receipt"
                      ></model-list-select>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="30" md-flex-small="100">
                      <model-list-select
                        @input="
                          getLocationList($event, 'All', 'finalAllPlaceDataPOD')
                        "
                        @searchchange="
                          getLocationList($event, 'All', 'finalAllPlaceDataPOD')
                        "
                        :list="finalAllPlaceDataPOD"
                        v-model="PODfilter"
                        option-value="pickupId"
                        option-text="pickupLocation"
                        placeholder="Select Port of Discharge"
                      ></model-list-select>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="30" md-flex-small="100">
                      <model-list-select
                        @input="
                          getLocationList($event, 'All', 'finalAllPlaceDataLP')
                        "
                        @searchchange="
                          getLocationList($event, 'All', 'finalAllPlaceDataLP')
                        "
                        :list="finalAllPlaceDataLP"
                        v-model="LPfilter"
                        option-value="pickupId"
                        option-text="pickupLocation"
                        placeholder="Select Load Port"
                      ></model-list-select>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter class="gutr">
                    <md-layout md-flex="30">
                      <model-list-select
                        @searchchange="
                          getCommodityList($event, 'commodityList')
                        "
                        :list="commodityList"
                        v-model="commodityFilter"
                        option-value="commodityId"
                        option-text="itemDescription"
                        placeholder="Select Commodity"
                      ></model-list-select>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="20">
                      <model-list-select
                        :list="containerList"
                        v-model="containerFilter"
                        option-value="containerTypeId"
                        option-text="containerType"
                        placeholder="Select Container Type"
                      ></model-list-select>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="20">
                      <model-list-select
                        :list="shippingList"
                        v-model="shippingFilter"
                        option-value="shippingId"
                        option-text="shippingLine"
                        placeholder="Select Shipping Line"
                      ></model-list-select>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="15">
                      <model-list-select
                        :list="airlineList"
                        v-model="airlineFilter"
                        option-value="airlineId"
                        option-text="airlineName"
                        placeholder="Select Airline "
                      ></model-list-select>
                    </md-layout>
                  </md-layout>
                  <div class="gutr">
                    <b-button
                      size="sm"
                      class="pull-right"
                      @click="filterSearch"
                      variant="outline-primary"
                      >Search</b-button
                    >
                    <b-button
                      style="margin-right: 5px"
                      size="sm"
                      class="pull-right"
                      @click="clearFilter"
                      variant="outline-info"
                      >clear</b-button
                    >
                  </div>
                </b-card>
              </b-collapse>
            </div>
            <!-- <div class="page-header pull-right">
              <div class="input-group">
                <date-picker
                  class="pull-right"
                  v-model="dateRangeEnq"
                  range
                  :lang="langEnq"
                  format="YYYY-MM-DD"
                  confirm
                  @input="onConfirmDateRangeEq"
                ></date-picker>
              </div>
            </div>-->
            <div class="gutr table-responsive">
              <b-table
                show-empty
                stacked="md"
                responsive
                bordered
                :items="consoBooking"
                :fields="fields"
                :per-page="perPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
              >
                <template slot="allModuleId" slot-scope="row0">
                  <span>{{
                    row0.index + 1 + (currentPage - 1) * perPage
                  }}</span>
                </template>
                <template slot="shipmentType" slot-scope="row1">
                  <span
                    >{{ row1.item.shipmentType == "1" ? "SEA" : "AIR" }} -
                    {{ row1.item.transportType }}</span
                  >
                </template>

                <template slot="multiConNo" slot-scope="row2">
                  <div v-if="row2.item.shipmentType == '1'">
                    <span>
                      Container Type : {{ row2.item.multipleContainerType }}
                      <br />
                    </span>
                    <span>
                      No.of Containers : {{ row2.item.multiConNo }}
                      <br />
                    </span>
                  </div>
                  <div v-else>
                    <span>
                      No.of Packages : {{ row2.item.noOfPkg }}
                      <br />
                    </span>
                  </div>
                </template>
                <template slot="POR" slot-scope="row3">
                  <div v-if="row3.item.shipmentType == '1'">
                    <span>
                      Place of Receipt : {{ row3.item.POR }}
                      <br />
                    </span>
                    <span>
                      Port of Load : {{ row3.item.LP }}
                      <br />
                    </span>
                    <span>
                      Port of Discharge : {{ row3.item.POD }}
                      <br />
                    </span>
                  </div>
                  <div v-else>
                    <span>
                      Departure Airport : {{ row3.item.departAirport }}
                      <br />
                    </span>
                    <span>
                      Destination Airport : {{ row3.item.destiAirport }}
                      <br />
                    </span>
                  </div>
                </template>
                <template slot="mainSalesSeries" slot-scope="row4">
                  <span
                    v-if="
                      row4.item.ffExecutionSeries != null &&
                      row4.item.ffExecutionSeries != ''
                    "
                  >
                    {{ row4.item.ffExecutionSeries }}
                    <br />
                  </span>
                  <span v-else>
                    {{ row4.item.mainSalesSeries }}
                    <br />
                  </span>
                </template>
                <!-- <template slot="finalAmount" slot-scope="row5">
                  <span @click="goToBill(row5.item.billingId)" class="showMoreData error">
                    {{row5.item.BillingSeries}}
                    <br>
                  </span>
                </template>-->
              </b-table>
            </div>

            <div>
              <b-pagination
                class="mt-4 pull-right"
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="totalRows"
                @change="onPageChange($event)"
                first-text="⏮"
                prev-text="⏪"
                next-text="⏩"
                last-text="⏭"
              ></b-pagination>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <!-- FF Starts Here -->
    <!-- TPT Ends Here -->
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
import {
  globalPermissionStatus,
  GlobalContainerValid,
  GlobalGetLocation,
  GlobalGetCommodity,
} from "../../../helper/collection";
import XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  beforeMount() {
    this.$store.dispatch("setCurrentRoute", "/dashboard");
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != "" &&
      this.$sessionsStorage.get("departmentName") != undefined &&
      this.$sessionsStorage.get("departmentName") != "" &&
      this.$sessionsStorage.get("designation") != undefined &&
      this.$sessionsStorage.get("designation") != ""
    ) {
      let { filterId } = this.$route.params;
      let { dateRange } = this.$route.params;
      this.reportSearchField = filterId;
      if (dateRange != "" && dateRange != undefined) {
        this.dateRangeEnq = dateRange.split(",");
      }
      //    const { price } = this.$route.params;

      this.viewFFExportFCL("0", "1", "1");
    } else {
      this.$sessionsStorage.set("loginId", "");
      this.$router.push({
        path: "/Login/",
      });
    }
  },

  data() {
    return {
      reportSearchField: "",
      particularStatus: "0",
      name: "BootstrapVue",
      show: true,
      headerFilter: [],
      docURL: URL_BASE_DOC,
      containerNoRegexError: "",
      containerNo: "",
      validContainerNo: "",
      totalRows: "",
      currentPage: 2,
      perPage: 10,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filterClient: "",
      searchValPickup: "",
      searchValHandover: "",
      searchValPOR: "",
      searchValPOD: "",
      searchValLP: "",

      fields: [
        {
          key: "allModuleId",
          mainkey: "allModuleId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "mainSalesSeries",
          mainkey: "mainSalesSeries",
          label: "Execution No.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "mainEnquirySeries",
          mainkey: "mainEnquirySeries",
          label: "Enquiry No.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "clientName",
          mainkey: "clientName",
          label: "Client Name",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "jobType",
          mainkey: "jobType",
          label: "Modules",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "shipmentType",
          mainkey: "shipmentType",
          label: "Shipment Mode",
          sortable: true,
          sortDirection: "ASC",
        },

        {
          key: "multiConNo",
          mainkey: "multiConNo",
          label: "No.of Containers / Packages",
          sortable: true,
          sortDirection: "ASC",
        },
        // {
        //   key: "ffContainerType",
        //   mainkey: "ffContainerType",
        //   label: "No.of Containers Executed",
        //   sortable: true,
        //   sortDirection: "ASC"
        // },

        {
          key: "POR",
          mainkey: "POR",
          label: "Location Details",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "tptVehicleCount",
          mainkey: "tptVehicleCount",
          label: "No.of Vehicle",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "tptVehicleType",
          mainkey: "tptVehicleType",
          label: "Vehicle Type",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "dieselAllocated",
          mainkey: "dieselAllocated",
          label: "Diesel Allocated",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "advanceCash",
          mainkey: "advanceCash",
          label: "Advance Cash",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "FuelSlipNo",
          mainkey: "FuelSlipNo",
          label: "Fuel Slip No.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "tollCash",
          mainkey: "tollCash",
          label: "Toll Cash",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "tollCard",
          mainkey: "tollCard",
          label: "Toll Card",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "finalAmount",
          mainkey: "finalAmount",
          label: "Invoice Ammount",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "itemHSNCode",
          mainkey: "itemHSNCode",
          label: "Commodity",
          sortable: true,
          sortDirection: "ASC",
        },
      ],
      isLoading: "",
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      consoBooking: [],
      cTypeList: [
        {
          cTypeVal: "1",
          cTypeText: "Client",
        },
        {
          cTypeVal: "2",
          cTypeText: "Lead",
        },
      ],
      finalAllPlaceDataPOR: [],
      finalAllPlaceDataPOD: [],
      finalAllPlaceDataLP: [],
      commodityList: [],
      airlineList: [],
      containerList: [],
      shippingList: [],
      clientType: "",
      clientId: "",
      transportType: "",
      shipmentType: "",
      jobType: "",
      enqOrExu: "",
      PORfilter: "",
      PODfilter: "",
      LPfilter: "",
      commodityFilter: "",
      shippingFilter: "",
      airlineFilter: "",
      containerFilter: "",
      reload: true,
      clientMaster: [],
      transportTypeName: [
        {
          transportTypeVal: "Export",
          transportTypeText: "Export",
        },
        {
          transportTypeVal: "Import",
          transportTypeText: "Import",
        },
      ],
      shipmentTypeList: [
        {
          shipmentTypeVal: "1",
          shipmentTypeText: "Sea",
        },
        {
          shipmentTypeVal: "2",
          shipmentTypeText: "Air",
        },
      ],
      jTypeList: [
        {
          jTypeVal: "TPT",
          jTypeText: "TPT",
        },
        {
          jTypeVal: "FF",
          jTypeText: "FF",
        },
        {
          jTypeVal: "CC",
          jTypeText: "CC",
        },
      ],
      eqExList: [
        {
          eVal: "1",
          eText: "Enquiry",
        },
        {
          eVal: "2",
          eText: "Execution",
        },
      ],
      dateRangeEnq: [],
      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },

      execPDFHead: [
        "Sr No.",
        "Execution No.",
        "Enquiry No.",
        "Shipper ",
        "Enquiry Type / Modules",

        "Shipment Mode",
        "No.of Containers",
        "Container Type",
        "Place of Receipt",
        "Load Port",
        "Port of Discharge",
        "Departure Airport",
        "Destination Airport",
        // "No.of Vehicle",
        // "Vehicle Type",
        // "Diesel Allocated",
        // "Advance Cash",
        // "Fuel Slip No",
        // "Toll Cash",
        // "Toll Card",
        "Invoice Amount",
      ],

      execPDFColumns: [
        "allModuleId",
        "mainSalesSeries",
        "mainEnquirySeries",
        "clientName",
        "jobType",
        "shipmentType",
        "multiConNo",
        "multipleContainerType",
        "POR",
        "LP",
        "POD",
        "departAirport",
        "destiAirport",
        // "tptVehicleCount",
        // "tptVehicleType",
        // "dieselAllocated",
        // "advanceCash",
        // "FuelSlipNo",
        // "tollCash",
        // "tollCard",
        "finalAmount",
      ],
    };
  },

  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
  },

  computed: {
    buttonDisable() {
      return this.mainModal.ffClientStatus == "2" ||
        this.mainModal.ffExpireStatus == "1"
        ? true
        : false;
    },
    fetchClientType() {
      return this.reportSearchField == "E1" ||
        this.reportSearchField == "E11" ||
        this.reportSearchField == "E11Export" ||
        this.reportSearchField == "E11Import" ||
        this.reportSearchField == "E11ExportFF" ||
        this.reportSearchField == "E11ExportCC" ||
        this.reportSearchField == "E11ExportTPT" ||
        this.reportSearchField == "E11ImportFF" ||
        this.reportSearchField == "E11ImportCC" ||
        this.reportSearchField == "E11ImportTPT" ||
        this.reportSearchField == "E12" ||
        this.reportSearchField == "E12Export" ||
        this.reportSearchField == "E12Import" ||
        this.reportSearchField == "E12ExportFF" ||
        this.reportSearchField == "E12ExportCC" ||
        this.reportSearchField == "E12ExportTPT" ||
        this.reportSearchField == "E12ImportFF" ||
        this.reportSearchField == "E12ImportCC" ||
        this.reportSearchField == "E12ImportTPT"
        ? "1"
        : this.reportSearchField == "L2" ||
          this.reportSearchField == "L21" ||
          this.reportSearchField == "L21Export" ||
          this.reportSearchField == "L21Import" ||
          this.reportSearchField == "L21ExportFF" ||
          this.reportSearchField == "L21ExportCC" ||
          this.reportSearchField == "L21ExportTPT" ||
          this.reportSearchField == "L21ImportFF" ||
          this.reportSearchField == "L21ImportCC" ||
          this.reportSearchField == "L21ImportTPT" ||
          this.reportSearchField == "L22" ||
          this.reportSearchField == "L22Export" ||
          this.reportSearchField == "L22Import" ||
          this.reportSearchField == "L22ExportFF" ||
          this.reportSearchField == "L22ExportCC" ||
          this.reportSearchField == "L22ExportTPT" ||
          this.reportSearchField == "L22ImportFF" ||
          this.reportSearchField == "L22ImportCC" ||
          this.reportSearchField == "L22ImportTPT"
        ? "2"
        : this.clientType;
    },
    fetchShipmentType() {
      return this.reportSearchField == "E11" ||
        this.reportSearchField == "E11Export" ||
        this.reportSearchField == "E11Import" ||
        this.reportSearchField == "E11ExportFF" ||
        this.reportSearchField == "E11ExportCC" ||
        this.reportSearchField == "E11ExportTPT" ||
        this.reportSearchField == "E11ImportFF" ||
        this.reportSearchField == "E11ImportCC" ||
        this.reportSearchField == "E11ImportTPT" ||
        this.reportSearchField == "L21" ||
        this.reportSearchField == "L21Export" ||
        this.reportSearchField == "L21Import" ||
        this.reportSearchField == "L21ExportFF" ||
        this.reportSearchField == "L21ExportCC" ||
        this.reportSearchField == "L21ExportTPT" ||
        this.reportSearchField == "L21ImportFF" ||
        this.reportSearchField == "L21ImportCC" ||
        this.reportSearchField == "L21ImportTPT"
        ? "1"
        : this.reportSearchField == "E12" ||
          this.reportSearchField == "E12Export" ||
          this.reportSearchField == "E12Import" ||
          this.reportSearchField == "E12ExportFF" ||
          this.reportSearchField == "E12ExportCC" ||
          this.reportSearchField == "E12ExportTPT" ||
          this.reportSearchField == "E12ImportFF" ||
          this.reportSearchField == "E12ImportCC" ||
          this.reportSearchField == "E12ImportTPT" ||
          this.reportSearchField == "L22" ||
          this.reportSearchField == "L22Export" ||
          this.reportSearchField == "L22Import" ||
          this.reportSearchField == "L22ExportFF" ||
          this.reportSearchField == "L22ExportCC" ||
          this.reportSearchField == "L22ExportTPT" ||
          this.reportSearchField == "L22ImportFF" ||
          this.reportSearchField == "L22ImportCC" ||
          this.reportSearchField == "L22ImportTPT"
        ? "2"
        : this.shipmentType;
    },
    fetchTransportType() {
      return this.reportSearchField == "E11Export" ||
        this.reportSearchField == "E11ExportFF" ||
        this.reportSearchField == "E11ExportCC" ||
        this.reportSearchField == "E11ExportTPT" ||
        this.reportSearchField == "E12Export" ||
        this.reportSearchField == "E12ExportFF" ||
        this.reportSearchField == "E12ExportCC" ||
        this.reportSearchField == "E12ExportTPT" ||
        this.reportSearchField == "L21Export" ||
        this.reportSearchField == "L21ExportFF" ||
        this.reportSearchField == "L21ExportCC" ||
        this.reportSearchField == "L21ExportTPT" ||
        this.reportSearchField == "L22Export" ||
        this.reportSearchField == "L22ExportFF" ||
        this.reportSearchField == "L22ExportCC" ||
        this.reportSearchField == "L22ExportTPT"
        ? "Export"
        : this.reportSearchField == "E11Import" ||
          this.reportSearchField == "E11ImportFF" ||
          this.reportSearchField == "E11ImportCC" ||
          this.reportSearchField == "E11ImportTPT" ||
          this.reportSearchField == "E12Import" ||
          this.reportSearchField == "E12ImportFF" ||
          this.reportSearchField == "E12ImportCC" ||
          this.reportSearchField == "E12ImportTPT" ||
          this.reportSearchField == "L21Import" ||
          this.reportSearchField == "L21ImportFF" ||
          this.reportSearchField == "L21ImportCC" ||
          this.reportSearchField == "L21ImportTPT" ||
          this.reportSearchField == "L22Import" ||
          this.reportSearchField == "L22ImportFF" ||
          this.reportSearchField == "L22ImportCC" ||
          this.reportSearchField == "L22ImportTPT"
        ? "Import"
        : this.transportType;
    },
    fetchJobType() {
      return this.reportSearchField == "E11ExportFF" ||
        this.reportSearchField == "E11ImportFF" ||
        this.reportSearchField == "E12ExportFF" ||
        this.reportSearchField == "E12ImportFF" ||
        this.reportSearchField == "L21ExportFF" ||
        this.reportSearchField == "L21ImportFF" ||
        this.reportSearchField == "L22ExportFF" ||
        this.reportSearchField == "L22ImportFF"
        ? "FF"
        : this.reportSearchField == "E11ExportCC" ||
          this.reportSearchField == "E11ImportCC" ||
          this.reportSearchField == "E12ExportCC" ||
          this.reportSearchField == "E12ImportCC" ||
          this.reportSearchField == "L21ExportCC" ||
          this.reportSearchField == "L21ImportCC" ||
          this.reportSearchField == "L22ExportCC" ||
          this.reportSearchField == "L22ImportCC"
        ? "CC"
        : this.reportSearchField == "E11ExportTPT" ||
          this.reportSearchField == "E11ImportTPT" ||
          this.reportSearchField == "E12ExportTPT" ||
          this.reportSearchField == "E12ImportTPT" ||
          this.reportSearchField == "L21ExportTPT" ||
          this.reportSearchField == "L21ImportTPT" ||
          this.reportSearchField == "L22ExportTPT" ||
          this.reportSearchField == "L22ImportTPT"
        ? "TPT"
        : this.jobType;
    },
  },
  watch: {
    // containerNo: {
    //   handler(newVal, oldVal) {
    //     let newCon = this.containerNo.toUpperCase();
    //     this.containerNo = newCon;
    //   },
    //   deep: true
    // }

    shipModal: {
      handler: function (newVal, oldVal) {
        if (
          this.shipModal.shippingId != "" &&
          this.shipModal.ffShippingWiseId == ""
        ) {
          let arrayDum = this.ffShipArry.filter((x) => {
            return x.shippingId == this.shipModal.shippingId;
          });

          if (arrayDum.length > 0) {
            this.alert.content = arrayDum[0].shippingLine + " Already Exists";
            this.$refs["addPopAlready"].open();

            return false;
          }
        }
      },

      deep: true,
    },
  },
  methods: {
    getCommodityList(event, vmodelArray) {
      let vehicle_drive = {
        value: event,
      };

      let self = this;

      if (event != "") {
        GlobalGetCommodity(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
              // console.log(self[vmodelArray]);
            }
          }
        });
      }
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };

      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    // goToBill(item) {
    //   this.$router.push({
    //     // path: "/allModuleForm/billing"
    //     path: "/allModuleForm/billing/" + item
    //   });
    // },
    onConfirmDateRangeEq() {
      this.viewFFExportFCL("0", "1");
    },

    onDownloadExcel() {
      this.isLoading = true;
      let type_Size = {
        excelData: "abc",
        pageName: "2PDF",
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_EmpDashboard/reportExportEnqExec.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.mainExecExcelPDFData.length > 0) {
              let mainArray = data.mainExecExcelPDFData;
              data.mainExecExcelPDFData.map((x, i) => {
                let dieselAllocated = 0;
                let tollCash = 0;
                let advanceCash = 0;
                let tollCard = 0;
                let finalAmountINR = 0;
                let finalAmountUSD = 0;
                if (
                  data.mainExecExcelPDFData[i].Diesel_Allocated != "" &&
                  data.mainExecExcelPDFData[i].Diesel_Allocated != null
                ) {
                  let dieselAllocatedArry =
                    data.mainExecExcelPDFData[i].Diesel_Allocated.split(",");
                  for (let p = 0; p < dieselAllocatedArry.length; p++) {
                    dieselAllocated =
                      dieselAllocated + parseFloat(dieselAllocatedArry[p]);
                  }
                  mainArray[i].Diesel_Allocated = parseFloat(dieselAllocated);
                }
                if (
                  data.mainExecExcelPDFData[i].Toll_Cash != "" &&
                  data.mainExecExcelPDFData[i].Toll_Cash != null
                ) {
                  let tollCashArry =
                    data.mainExecExcelPDFData[i].Toll_Cash.split(",");
                  for (let j = 0; j < tollCashArry.length; j++) {
                    tollCash = tollCash + parseFloat(tollCashArry[j]);
                  }
                  mainArray[i].Toll_Cash = parseFloat(tollCash);
                }

                if (
                  data.mainExecExcelPDFData[i].Advance_Cash != "" &&
                  data.mainExecExcelPDFData[i].Advance_Cash != null
                ) {
                  let advanceCashArry =
                    data.mainExecExcelPDFData[i].Advance_Cash.split(",");
                  for (let q = 0; q < advanceCashArry.length; q++) {
                    advanceCash = advanceCash + parseFloat(advanceCashArry[q]);
                  }
                  mainArray[i].Advance_Cash = parseFloat(advanceCash);
                }
                if (
                  data.mainExecExcelPDFData[i].Toll_Card != "" &&
                  data.mainExecExcelPDFData[i].Toll_Card != null
                ) {
                  let tollCardA =
                    data.mainExecExcelPDFData[i].Toll_Card.split(",");
                  for (let r = 0; r < tollCardA.length; r++) {
                    tollCard = tollCard + parseFloat(tollCardA[r]);
                  }
                  mainArray[i].Toll_Card = parseFloat(tollCard);
                }

                if (
                  data.mainExecExcelPDFData[i].Invoice_Amount != "" &&
                  data.mainExecExcelPDFData[i].Invoice_Amount != null &&
                  data.mainExecExcelPDFData[i].currency != "" &&
                  data.mainExecExcelPDFData[i].currency != null
                ) {
                  let currencyA =
                    data.mainExecExcelPDFData[i].currency.split(",");
                  let finalAmountA =
                    data.mainExecExcelPDFData[i].Invoice_Amount.split(",");
                  for (let s = 0; s < currencyA.length; s++) {
                    if (currencyA[s] == "USD") {
                      finalAmountUSD =
                        finalAmountUSD + parseFloat(finalAmountA[s]);
                    }
                    if (currencyA[s] == "INR") {
                      finalAmountINR =
                        finalAmountINR + parseFloat(finalAmountA[s]);
                    }
                    mainArray[i].Invoice_Amount =
                      parseFloat(finalAmountINR) +
                      " INR , " +
                      parseFloat(finalAmountUSD) +
                      " USD  ";
                  }
                }

                this.execPDFColumns.map((y) => {
                  if (x.hasOwnProperty(y)) {
                    x.Sr_No = i + 1;
                    x.Execution_No =
                      x.ffExecutionSeries != null && x.ffExecutionSeries != ""
                        ? x.ffExecutionSeries
                        : x.Execution_No;
                    x.Shipment_Mode = x.Shipment_Mode == "1" ? "SEA" : "AIR";
                    x.Diesel_Allocated = dieselAllocated;
                    x.Toll_Cash = tollCash;
                    x.Advance_Cash = advanceCash;
                    x.Toll_Card = tollCard;
                  }
                });
              });

              var ffExcelReport = XLSX.utils.json_to_sheet(mainArray, {
                header: [
                  "Sr_No",
                  "Execution_No",
                  "Enquiry_No",
                  "Client_Name",
                  "Job_Type",
                  "Shipment_Mode",
                  "No_of_Containers",
                  "Container_Type",
                  "POR",
                  "LP",
                  "POD",
                  "No_of_Vehicle",
                  "Vehicle_Type",
                  "Diesel_Allocated",
                  "Advance_Cash",
                  "Fuel_Slip_No",
                  "Toll_Cash",
                  "Toll_Card",
                  "Invoice_Amount",
                ],
              });
              var wb = XLSX.utils.book_new();
              wb.Title = "Insert Title Here";
              XLSX.utils.book_append_sheet(wb, ffExcelReport, "SheetOne"); // sheetAName is name of Worksheet
              // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons");
              XLSX.writeFile(
                wb,
                "EXECUTION_REPORT_" + new Date().toDateString() + ".xlsx"
              );
            } else {
              //this.showMessageSnackbar("No data available");
            }
          }

          this.isLoading = false;
        })
        .catch((error) => {});
    },
    onPageChange: function (event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.viewFFExportFCL(CURRENT, "2", event);

      // let totalRows = 1064 / this.perPage;
      // if(this.totalRow )
    },
    previousDash() {
      window.history.go(-1);
    },
    filterSearch() {
      this.reload = false;
      this.viewFFExportFCL("0", "1");
    },
    clearFilter() {
      shippingFilter = "";
      airlineFilter = "";
      containerFilter = "";
      this.clientType = "";
      this.clientId = "";
      this.transportType = "";
      this.shipmentType = "";
      this.jobType = "";
      this.enqOrExu = "";
      this.commodityFilter = "";
      this.PORfilter = "";
      this.PODfilter = "";
      this.LPfilter = "";
      this.viewFFExportFCL("0", "1");
    },

    viewFFExportFCL(CURRENT, SEARCH, pageNumber) {
      this.isLoading = true;
      let payload = {
        clientId: this.clientId,
        clientType: this.fetchClientType,
        shipmentType: this.fetchShipmentType,
        transportType: this.fetchTransportType,
        jobType: this.fetchJobType,
        enqOrExu: this.enqOrExu,
        PORfilter: this.PORfilter,
        PODfilter: this.PODfilter,
        LPfilter: this.LPfilter,
        shippingFilter: this.shippingFilter,
        airlineFilter: this.airlineFilter,
        containerFilter: this.containerFilter,
        commodityFilter: this.commodityFilter,
        fromDateRngEnq: this.dateRangeEnq[0],
        toDateRngEnq: this.dateRangeEnq[1],

        fields: this.fields,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,

        assignmentNo: "assignmentNo",
        pageName: "2",
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_EmpDashboard/getDashboardReportsDetails.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (SEARCH != "2") {
              this.currentPage = 1;
              this.totalRows = data.totalData;
            } else {
              this.currentPage = pageNumber;
            }
            if (data.mainExecData.length > 0) {
              this.consoBooking = data.mainExecData;
              for (let i = 0; i < data.mainExecData.length; i++) {
                if (
                  data.mainExecData[i].tollCash != "" &&
                  data.mainExecData[i].tollCash != null
                ) {
                  let tollCash = 0;
                  let tollCashArry = data.mainExecData[i].tollCash.split(",");
                  for (let j = 0; j < tollCashArry.length; j++) {
                    tollCash = tollCash + parseFloat(tollCashArry[j]);
                  }
                  this.consoBooking[i].tollCash = parseFloat(tollCash);
                }
                if (
                  data.mainExecData[i].dieselAllocated != "" &&
                  data.mainExecData[i].dieselAllocated != null
                ) {
                  let dieselAllocated = 0;
                  let dieselAllocatedArry =
                    data.mainExecData[i].dieselAllocated.split(",");
                  for (let p = 0; p < dieselAllocatedArry.length; p++) {
                    dieselAllocated =
                      dieselAllocated + parseFloat(dieselAllocatedArry[p]);
                  }
                  this.consoBooking[i].dieselAllocated =
                    parseFloat(dieselAllocated);
                }
                if (
                  data.mainExecData[i].advanceCash != "" &&
                  data.mainExecData[i].advanceCash != null
                ) {
                  let advanceCash = 0;
                  let advanceCashArry =
                    data.mainExecData[i].advanceCash.split(",");
                  for (let q = 0; q < advanceCashArry.length; q++) {
                    advanceCash = advanceCash + parseFloat(advanceCashArry[q]);
                  }
                  this.consoBooking[i].advanceCash = parseFloat(advanceCash);
                }
                if (
                  data.mainExecData[i].tollCard != "" &&
                  data.mainExecData[i].tollCard != null
                ) {
                  let tollCard = 0;
                  let tollCardA = data.mainExecData[i].tollCard.split(",");
                  for (let r = 0; r < tollCardA.length; r++) {
                    tollCard = tollCard + parseFloat(tollCardA[r]);
                  }
                  this.consoBooking[i].tollCard = parseFloat(tollCard);
                }
                if (
                  data.mainExecData[i].currency != "" &&
                  data.mainExecData[i].currency != null &&
                  data.mainExecData[i].finalAmount != "" &&
                  data.mainExecData[i].finalAmount != null
                ) {
                  let finalAmountINR = 0;
                  let finalAmountUSD = 0;
                  let currencyA = data.mainExecData[i].currency.split(",");
                  let finalAmountA =
                    data.mainExecData[i].finalAmount.split(",");
                  for (let s = 0; s < currencyA.length; s++) {
                    if (currencyA[s] == "USD") {
                      finalAmountUSD =
                        finalAmountUSD + parseFloat(finalAmountA[s]);
                    }
                    if (currencyA[s] == "INR") {
                      finalAmountINR =
                        finalAmountINR + parseFloat(finalAmountA[s]);
                    }
                    this.consoBooking[i].finalAmount =
                      parseFloat(finalAmountINR) +
                      " INR , " +
                      parseFloat(finalAmountUSD) +
                      " USD  ";
                  }
                }
              }
            } else {
              this.consoBooking = [];
            }
            if (data.clientMaster.length > 0) {
              this.clientMaster = data.clientMaster;
            } else {
              this.consoBooking = [];
            }
            if (this.reload == true) {
              if (data.LocationDetailsFinal.length > 0) {
                this.finalAllPlaceDataPOR = data.LocationDetailsFinal;
                this.finalAllPlaceDataPOD = data.LocationDetailsFinal;
                this.finalAllPlaceDataLP = data.LocationDetailsFinal;
              }
              if (data.shippingList.length > 0) {
                this.shippingList = data.shippingList;
              }
              if (data.airlineList.length > 0) {
                this.airlineList = data.airlineList;
              }
              if (data.containerList.length > 0) {
                this.containerList = data.containerList;
              }
              if (data.commodityList.length > 0) {
                this.commodityList = data.commodityList;
              }
            }

            this.isLoading = false;
            // this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style scoped>
.appMargin0 {
  margin-left: 0px !important;
  margin-right: 100px;
  transition: 5s !important;
}
.modal fade show d-block {
  background: none;
}
</style>



// WEBPACK FOOTER //
// dashboardReportsExecList.vue?53000e84